import { render, staticRenderFns } from "./TelefonNumarasi.vue?vue&type=template&id=e5c77f28"
import script from "./TelefonNumarasi.vue?vue&type=script&lang=ts"
export * from "./TelefonNumarasi.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports